import { isEmbeddedExperience } from './embeddedExperienceUtil';

/*
 * Route prefixes (matched on pathname, not app name) that can render inside
 * an LMS iframe embed. Everything else renders to the `IframeBlockerPage`.
 */
const IFRAME_ALLOWED_ROUTE_PATTERNS: readonly RegExp[] = [
  /^\/learn\//,
  /^\/videos\//,
  /^\/lecture\//,
  /^\/sso\//,
  /^\/login(?:\/|$)/,
  /^\/ssoCallback(?:\/|$)/,
  /^\/magicLinks\//,
  /^\/ssoSamlMagicLinks\//,
  /^\/(?:programs|organizations)\/[^/]+\/(?:learn|projects|specializations|professional-certificates)(?:\/|$)/,
  /^\/native-lti(?:\/|$)/,
  /^\/lti-instructor-flow(?:\/|$)/,
];

export const isRouteBlockedInIframe = (pathname: string | undefined): boolean =>
  isEmbeddedExperience() && !IFRAME_ALLOWED_ROUTE_PATTERNS.some((pattern) => pattern.test(pathname ?? ''));
